import React from 'react'

const Heading = ({text}) => {
  return (
    <div className='heading'>
        
    <hr /><h2>{text}</h2><hr />
      
    </div>
  )
}

export default Heading
